import { CustomFontSource, loadStripe, StripeElements, StripeElementsOptions } from '@stripe/stripe-js'
import { defaultMemoize } from 'reselect'

const STRIPE_KEY = __STRIPE_KEY__

export const getStripe = defaultMemoize(() => {
  return loadStripe(STRIPE_KEY)
})

let elements: StripeElements | null
export const setElements = (nextElements: StripeElements | null) => {
  elements = nextElements
}

export const getElements = () => {
  return elements
}

const createFontFace = (baseUrl: string, family = 'Graphik') => (weight: number, filename: string, format = 'woff'): CustomFontSource => {
  return {
    family,
    src: `local("${ family }"), url(${ baseUrl }/fonts/${ filename }.${ format }) format("${ format }")`,
    weight: `${ weight }`,
  }
}

const { host, protocol } = location
const fontsBase = `${ protocol }//${ host }`

const fontFace = createFontFace(fontsBase)
const getStripeFonts = () => ([
  fontFace(400, 'Graphik-Regular'),
  fontFace(500, 'Graphik-Medium'),
  fontFace(600, 'Graphik-Semibold'),
  fontFace(700, 'Graphik-Bold'),
])


const getStripeOptions = (): StripeElementsOptions => ({
  fonts: getStripeFonts(),
  locale: 'en',
})

export const STRIPE_OPTIONS = getStripeOptions()
